import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/categories' },
  { label: '文章', href: '/articles' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 py-4 flex items-center justify-between" aria-label="主导航">
        <a href="/" className="flex items-center gap-2 no-underline">
          <span className="font-heading text-2xl tracking-wide" style={{ color: scrolled || !isHome ? 'oklch(var(--primary-600))' : 'white' }}>
            jinman
          </span>
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === link.href
                  ? scrolled || !isHome ? 'text-primary-600' : 'text-white'
                  : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="切换菜单"
          aria-expanded={mobileOpen}
        >
          <i
            className={`text-xl ${scrolled || !isHome ? 'text-foreground-800' : 'text-white'} ${
              mobileOpen ? 'ri-close-line' : 'ri-menu-line'
            }`}
          ></i>
        </button>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium py-2 whitespace-nowrap ${
                  location.pathname === link.href
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}